/*
PURPOSE: The real AllInOneCoralCreator wrapped in the base1 editorial card
treatment (the sandbox RestyledCreatorCard look), shared by the the home page hero
and the How It Works mobile slot.
USE CASES:
- Desktop hero creator and mobile How-It-Works creator on the home page.
DOMAIN BOUNDARIES:
- Presentation wrapper only. Renders the production AllInOneCoralCreator with
  its `editorial` base1 theme (+ compact). The theme defaults off, so legacy
  Home and the other shared consumers are byte-identical and unaffected.
- No imports from design-sandbox/.
*/

import React from 'react';
import AllInOneCoralCreator from '../../../components/AllInOneCoralCreator/AllInOneCoralCreator';

interface EditorialCreatorCardProps {
  className?: string;
}

const EditorialCreatorCard: React.FC<EditorialCreatorCardProps> = ({ className }) => {
  return (
    <div
      className={`bg-white rounded-3xl shadow-[0_24px_48px_-24px_rgba(12,19,45,0.18)] border border-editorial-muted/5 ${className ?? ''}`}
    >
      <AllInOneCoralCreator editorial compact />
    </div>
  );
};

export default EditorialCreatorCard;
